import { Text } from 'src/onboarding/components/typography/Text/Text';
import styles from './style.module.scss';
import { t } from '@web-solutions/module-localization';
import { Caption } from 'src/onboarding/components/typography/Caption/Caption';
import { images } from 'src/onboarding/constants/images';


const BeforeAfterCardVine = () => {
  return (
    <div className={styles.beforeAfterContainer}>
      <div className={styles.weightCard}>
        <div className={`${styles.imageWrapper} ${styles.beforeImage}`}>
          <img src={images.dietImg} alt='Current' />
          <Caption className={`${styles.label} ${styles.now}`}>
            {t('onboarding.beforeAfterCardVine.before')}
          </Caption>
        </div>
        <div className={styles.info}>
          <Caption size='s' className={styles.weightLabel}>
            {t('onboarding.beforeAfterCardVine.nutrition')}
          </Caption>
          <Text size='s' semibold className={styles.weightValue}>
            {t('onboarding.beforeAfterCardVine.restrictions')}
          </Text>
          <div className={styles.nutritionBar}>
            <Caption size='s' className={styles.weightLabel}>
              {t('onboarding.beforeAfterCardVine.score')}
            </Caption>
            <div className={styles.progress}>
              <span className={styles.progressGreen}></span>
              <span></span>
              <span></span>
            </div>
          </div>
        </div>
      </div>

      <div className={styles.weightCard}>
        <div className={`${styles.imageWrapper} ${styles.afterImage}`}>
          <img src={images.vineImg} alt='After' />
          <Caption className={`${styles.label} ${styles.goal}`}>
            {t('onboarding.beforeAfterCardVine.after')}
          </Caption>
        </div>
        <div className={styles.info}>
          <Caption size='s' className={styles.weightLabel}>
            {t('onboarding.beforeAfterCardVine.nutrition')}
          </Caption>
          <Text size='s' semibold className={styles.weightValue}>
            {t('onboarding.beforeAfterCardVine.balance')}
          </Text>
          <div className={styles.nutritionBar}>
            <Caption size='s' className={styles.weightLabel}>
              {t('onboarding.beforeAfterCardVine.score')}
            </Caption>
            <div className={styles.progress}>
              <span className={styles.progressGreen}></span>
              <span className={styles.progressGreen}></span>
              <span className={styles.progressGreen}></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BeforeAfterCardVine;
